import { Navigate } from 'react-router-dom';
import { ChannelModuleLayout } from '@/features/marketing-shared/ui/channel-module-layout';
import { SmsMarketingProvider, useSmsMarketing } from '../model/context';
import { useSmsMarketingPaths } from '../model/paths';

function ModuleFrame() {
  const { gate, campaignsState } = useSmsMarketing();
  return (
    <ChannelModuleLayout
      title="SMS marketing"
      description="Módulo separado do e-mail e das campanhas atuais."
      gate={gate}
      onRetry={campaignsState.refetch}
      deniedTitle="Sem permissão para SMS marketing"
      deniedDescription="O acesso deste módulo é separado do e-mail marketing e das campanhas atuais. Só Admin, Client ou Owner da loja entram aqui."
      uncontractedTitle="SMS marketing não contratado"
      uncontractedDescription="Este módulo tem contratação própria. O e-mail marketing e as campanhas que você já usa continuam no menu. Para contratar, fale com o time da Fixe."
    />
  );
}

export function SmsMarketingLayout() {
  return (
    <SmsMarketingProvider>
      <ModuleFrame />
    </SmsMarketingProvider>
  );
}

export function SmsMarketingIndexRedirect() {
  const paths = useSmsMarketingPaths();
  return <Navigate to={paths.list} replace />;
}
